import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { usePrevious } from 'hooks/usePrevious';
import Portal from 'layout/atoms/Portal/Portal';
import { addChat, addChatMessage, closeScreenshot, fetchChat, openScreenshot, selectChat, selectChatRefetchFlags, selectChatStatus, } from 'store/chatSlice';
import { activateSidebar, closeSidebar, removeSidebar, selectSidebarByName, } from 'store/layoutSlice';
import { selectFolderName } from 'store/specificationsFoldersSlice';
import ScreenCropper from './ScreenCropper';
import Screenshot from './Screenshot';
function ScreenCropperController() {
    const { t } = useTranslation(['specifications']);
    const dispatch = useDispatch();
    const location = useLocation();
    const takeScreenshotFlag = useSelector(selectChat).screenshotOpened;
    const status = useSelector(selectChatStatus);
    const refetchFlags = useSelector(selectChatRefetchFlags);
    const chatId = useSelector(selectChat).id;
    const rootFolder = useSelector((state) => state.specificationsFolders.rootFolder);
    const folderId = location.pathname.includes('/specifications/folders/')
        ? location.pathname.replace('/specifications/folders/', '')
        : rootFolder === null || rootFolder === void 0 ? void 0 : rootFolder.rootFolderId;
    const folderName = useSelector((state) => selectFolderName(state, folderId));
    const folderDisplayName = folderId === rootFolder.rootFolderId ? t('all_folders') : folderName;
    const specificationName = useSelector((state) => { var _a, _b; return (_b = (_a = state.specificationDetails) === null || _a === void 0 ? void 0 : _a.item) === null || _b === void 0 ? void 0 : _b.fancyName; }) || '-';
    const [image, setImage] = useState(null);
    const [cropperVisible, setCropperVisible] = useState(false);
    const sidebar = useSelector(selectSidebarByName('screenshot'));
    const { opened: sidebarOpened, active: sidebarActive } = sidebar || {};
    const prevSidebarActive = usePrevious(sidebarActive);
    useEffect(() => {
        dispatch(openScreenshot());
    }, [dispatch]);
    useEffect(() => {
        if (sidebarOpened) {
            setTimeout(() => {
                dispatch(activateSidebar({ name: 'screenshot' }));
            }, 10);
        }
    }, [dispatch, sidebarOpened]);
    useEffect(() => {
        if (prevSidebarActive && !sidebarActive) {
            setCropperVisible(false);
            setImage(null);
            setTimeout(() => {
                dispatch(removeSidebar({ name: 'screenshot' }));
            }, 350);
        }
    }, [dispatch, sidebarActive, prevSidebarActive]);
    useEffect(() => {
        dispatch(openScreenshot());
        if (status.fetch === 'idle' || refetchFlags.fetch) {
            dispatch(fetchChat({ url: location.pathname }));
            dispatch(addChat({
                url: location.pathname,
                title: location.pathname.startsWith('/specifications/details')
                    ? specificationName
                    : folderDisplayName,
            }));
        }
    }, [dispatch, location, status.fetch, refetchFlags.fetch, folderDisplayName, specificationName]);
    useEffect(() => {
        if (takeScreenshotFlag) {
            Screenshot.take(document.querySelector('body'), 'userMedia').then((dataUrl) => {
                setImage(dataUrl);
                setCropperVisible(true);
                // dispatch(resetScreenshot());
            });
        }
    }, [takeScreenshotFlag, dispatch]);
    const handleCropImage = (croppedFile) => {
        dispatch(addChatMessage({ conversationId: chatId, image: croppedFile }));
        dispatch(closeScreenshot());
        dispatch(closeSidebar({ name: 'screenshot' }));
    };
    return (React.createElement(Portal, null, image && (React.createElement(ScreenCropper, { open: cropperVisible, data: image, onTakeScreenshot: handleCropImage }))));
}
export default ScreenCropperController;
